import { WithClassName } from '@/blocks/components/types';
import classNames from 'classnames';
import { CSSProperties, PropsWithChildren } from 'react';
import styles from './styles.module.scss';

export function Panel({
  children,
  className,
  innerContentMaxWidthDesktop,
}: PropsWithChildren<{ innerContentMaxWidthDesktop?: number } & WithClassName>) {
  const s = innerContentMaxWidthDesktop
    ? { '--inner-content-max-width': innerContentMaxWidthDesktop + 'px' }
    : {};
  return (
    <div className={classNames(styles.panel, className)} style={s as CSSProperties}>
      <div>{children}</div>
    </div>
  );
}
